import React from "react";
import logo from "./logo.svg";
import classes from "./globals/Globals.module.scss";
import "./globals/css_reset.css";
import { ThemeProvider } from "@emotion/react";
import { theme } from "./globals/theme";
import { CssBaseline, IconButton } from "@mui/material";
import Router from "./router/Router";
import Loading from "./components/uikit/Loading";
import { useZoom } from "./hooks/util/useZoom";
function App() {
  useZoom();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Loading>
        <Router />
      </Loading>
    </ThemeProvider>
  );
}

export default App;
